import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import Close from '../../assets/close/Close';
import GridCell from '../grid/gridCell/GridCell';
import './Option.css';

const EXAMPLES = ['WEARY', 'PILLS', 'VAGUE'];

export default function Option({
    handleClose,
    display,
    option,
    textStatistics,
    graphStatistics,
}) {
    if (option === 'help') {
        return (
            <div className="option-container" style={{ display: display }}>
                <div className="option-content-container">
                    <header className="option-header">
                        <h1 className="option-header-title">how to play?</h1>
                        <button
                            id="button-close"
                            type="button"
                            className="button-close"
                            aria-label="Close menu"
                            onClick={handleClose}
                        >
                            <Close />
                        </button>
                    </header>
                    <div className="model-content">
                        <div className="option-instructions">
                            <p>
                                Guess the
                                <strong> WORDLE </strong>
                                in six tries.
                            </p>
                            <p>
                                Each guess must be a valid five-letter word. Hit the enter button to submit.
                            </p>
                            <p>
                                After each guess, the color of the tiles will change to show how close your guess was to the word.
                            </p>
                        </div>
                        <div className="option-examples">
                            <p>
                                <strong>Examples</strong>
                            </p>
                            <div className="option-example">
                                <div className="option-example-grid">
                                    {EXAMPLES[0].split('').map((x) => x.split('')).map((key, index) => {
                                        const letterObject = [];
                                        letterObject.push({ status: index === 0 ? 'correct' : '', letter: key.toString() });
                                        const keyID = nanoid();
                                        return (
                                            <GridCell
                                                key={keyID}
                                                index={index}
                                                letterObject={letterObject[0]}
                                            />
                                        );
                                    })}
                                </div>
                                <p>
                                    The letter
                                    <strong> W </strong>
                                    is in the word and in the correct spot.
                                </p>
                            </div>
                            <div className="option-example">
                                <div className="option-example-grid">
                                    {EXAMPLES[1].split('').map((x) => x.split('')).map((key, index) => {
                                        const letterObject = [];
                                        letterObject.push({ status: index === 1 ? 'misplaced' : '', letter: key.toString() });
                                        const keyID = nanoid();
                                        return (
                                            <GridCell
                                                key={keyID}
                                                index={index}
                                                letterObject={letterObject[0]}
                                            />
                                        );
                                    })}
                                </div>
                                <p>
                                    The letter
                                    <strong> I </strong>
                                    is in the word but in the wrong spot.
                                </p>
                            </div>
                            <div className="option-example">
                                <div className="option-example-grid">
                                    {EXAMPLES[2].split('').map((x) => x.split('')).map((key, index) => {
                                        const letterObject = [];
                                        letterObject.push({ status: index === 3 ? 'wrong' : '', letter: key.toString() });
                                        const keyID = nanoid();
                                        return (
                                            <GridCell
                                                key={keyID}
                                                index={index}
                                                letterObject={letterObject[0]}
                                            />
                                        );
                                    })}
                                </div>
                                <p>
                                    The letter
                                    <strong> U </strong>
                                    is not in the word in any spot.
                                </p>
                            </div>
                        </div>
                        <div className="option-footer">
                            <p>
                                <strong>A new WORDLE will be available each day!</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (option === 'statistics') {
        return (
            <div className="option-container-small" style={{ display: display }}>
                <div className="option-content-container-small">
                    <header className="option-header">
                        <h1 className="option-header-title">STATISTICS</h1>
                        <button
                            id="button-close"
                            type="button"
                            className="button-close"
                            aria-label="Close statistics"
                            onClick={handleClose}
                        >
                            <Close />
                        </button>
                    </header>
                    <div className="model-content">
                        <div className="option-instructions">
                            <table className="option-statistics-text-table">
                                <tbody>
                                    <tr>
                                        <th>{textStatistics.played}</th>
                                        <th>{((textStatistics.win / textStatistics.played) * 100).toFixed(1)}</th>
                                        <th>{textStatistics.currentStreak}</th>
                                        <th>{textStatistics.maxStreak}</th>
                                    </tr>
                                    <tr>
                                        <th>Played</th>
                                        <th>Win %</th>
                                        <th>Current Streak</th>
                                        <th>Max Streak</th>
                                    </tr>
                                </tbody>
                            </table>
                            <h1 className="option-header-title">GUESS DISTRIBUTION</h1>
                            <table className="option-statistics-graph-table">
                                <tbody>
                                    <tr>
                                        <th>1</th>
                                        <th>{graphStatistics.one}</th>
                                    </tr>
                                    <tr>
                                        <th>2</th>
                                        <th>{graphStatistics.two}</th>
                                    </tr>
                                    <tr>
                                        <th>3</th>
                                        <th>{graphStatistics.three}</th>
                                    </tr>
                                    <tr>
                                        <th>4</th>
                                        <th>{graphStatistics.four}</th>
                                    </tr>
                                    <tr>
                                        <th>5</th>
                                        <th>{graphStatistics.five}</th>
                                    </tr>
                                    <tr>
                                        <th>6</th>
                                        <th>{graphStatistics.six}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (option === 'settings') {
        return (
            <div className="option-container-small" style={{ display: display }}>
                <div className="option-content-container-small">
                    <header className="option-header">
                        <h1 className="option-header-title">settings</h1>
                        <button
                            id="button-close"
                            type="button"
                            className="button-close"
                            aria-label="Close settings"
                            onClick={handleClose}
                        >
                            <Close />
                        </button>
                    </header>
                    <div className="model-content-statistics">
                        <div className="option-instructions">
                            <p>In Progress</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Option.defaultProps = {
    display: 'none',
    handleClose: '',
    option: '',
    textStatistics: {},
    graphStatistics: {},
};

Option.propTypes = {
    display: PropTypes.string,
    handleClose: PropTypes.func,
    option: PropTypes.string,
    textStatistics: PropTypes.instanceOf(Object),
    graphStatistics: PropTypes.instanceOf(Object),
};
